export default __webpack_public_path__ + "static/media/722.6ef09b08.gif";